<template>
  <!-- 信用限额table -->
  <div>
    <a-table
      :columns="creditLimitColumns"
      :data-source="limitAmount"
      :pagination="pageData"
      bordered
      :scroll="SCROLL"
      row-key="id"
    >
      <span slot="type">信用限额</span>
      <span slot="amount" slot-scope="text">{{ text | formatAmount }}</span>
      <span slot="totalWithRoadAmount" slot-scope="text, record">
        {{ record.limitAmountFinal | formatAmount }}
      </span>
      <span slot="indateStart" slot-scope="text">{{ text }}</span>

      <span slot="indateEnd" slot-scope="text">至 {{ text }}</span>

      <template slot="limitConditionType" slot-scope="text, record">
        <span v-if="!record.limitConditionType">无</span>
        <span v-else>
          NET AR 超 {{ record.limitConditionAmount | formatAmount }} 元控货
        </span>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button type="link" size="small" @click="handleEdit(record, record)">
          延长额度有效期
        </a-button>
      </template>
    </a-table>

    <a-modal
      v-model="visible"
      destroyOnClose
      :maskClosable="false"
      title="延长额度有效期"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="额度有效期">
          <a-date-picker
            v-decorator="['indateEnd']"
            placeholder="请选择"
            format="YYYY-MM-DD"
            disabled="disabled"
          />
        </a-form-item>
        <a-form-item label="延长额度有效期至">
          <a-date-picker
            v-decorator="$decorator('newIndateEnd', '请选择有效期')"
            v-model="newIndateEnd"
            placeholder="请选择"
            format="YYYY-MM-DD"
          />
        </a-form-item>
        <a-form-item label="请选择信用主管审批人">
        <a-select
          allowClear
          showSearch
          style="width: 200px"
          option-filter-prop="children"
          v-decorator="$decorator('creditManager', '请选择信用主管审批人')"
          @change="value => getCreditManager(value)"
        >
          <a-select-option
            v-for="manager in managerList"
            :key="manager.username"
            :value="manager.username"
          >
            {{ manager.name }} - {{ manager.username }}
          </a-select-option>
        </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button  @click="closeMessage">关闭</a-button>
        <a-button type="primary" @click="handleSubmit(newIndateEnd)" >
          提交
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import {
  TYPE_WIDTH,
  INDATE_WIDTH,
  INDATE_START_WIDTH,
  SCROLL,
} from '../../components/ApplyDetail/config'
import { CREDIT_TYPE_VALUE_OBJ } from '../../const'
import { addLimit, getManagerList} from '../api'

const data = []

export default {
  name: 'ContactInfo',
  props: ['limitAmount', 'typeOperate', 'pageData'],
  data() {
    return {
      managerList: [],
      approvePerson: '',
      modalForm: this.$form.createForm(this),
      data,
      moment,
      visible: false,
      CREDIT_TYPE_VALUE_OBJ,
      SCROLL,
      submitData: {},
      newIndateEnd: "",
      creditLimitColumns: [
        {
          title: '信用类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          width: TYPE_WIDTH,
        },
        {
          title: '本次申请增加额度(元)',
          dataIndex: 'amount',
          slots: { title: 'amountTitle' },
          scopedSlots: { customRender: 'amount' },
          width: 170,
        },
        {
          title: '货币',
          dataIndex: 'moneyName',
          width: 90,
        },
        {
          title: '申请后限额峰值',
          dataIndex: 'totalWithRoadAmount',
          scopedSlots: { customRender: 'totalWithRoadAmount' },
          width: 150,
        },
        {
          title: '额度生效日',
          dataIndex: 'indateStart',
          slots: { title: 'indateStartTitle' },
          scopedSlots: { customRender: 'indateStart' },
          width: INDATE_START_WIDTH,
        },
        {
          title: '额度有效期',
          dataIndex: 'indateEnd',
          slots: { title: 'indateEndTitle' },
          scopedSlots: { customRender: 'indateEnd' },
          width: INDATE_WIDTH,
        },
        {
          title: '账期(天)',
          dataIndex: 'term',
          width: 100,
        },
        {
          title: '限额条件',
          dataIndex: 'limitConditionType',
          slots: { title: 'limitConditionTypeTitle' },
          scopedSlots: { customRender: 'limitConditionType' },
          width: 150,
        },
        {
          title: '操作',
          width: 150,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  mounted() {
    this.query()
    this.fetchManagerList()
  },
  methods: {
    async fetchManagerList() {
      try {
        const { data } = await getManagerList()
        this.managerList = data
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    async query() {
      this.data = this.customerDetail
    },
    //延长
    async handleEdit({id, indateEnd}, record) {
      this.visible = true
      this.submitData = record
      this.submitData.cbaId = id
      this.submitData.oldIndateEnd = record.indateEnd
      this.submitData.updateTime = ""
      this.submitData.createTime = ""
      setTimeout(() => {
        this.$nextTick(() => {
          this.modalForm.setFieldsValue({
            indateEnd,
            id,
          })
        })
      }, 20)
    },
    async getCreditManager(data){
      this.approvePerson = data
    },
    // 提交
    handleSubmit(newIndateEnd) {
      this.modalForm.validateFields(async (err) => {
        if (!err) {
          if (!this.id) {
            this.id = new Date().getTime()
          }
          try {
            // moment(newIndateEnd).isBefore(moment().format('YYYY-MM-DD'))
            // if (moment(this.submitData.oldIndateEnd) >= moment(newIndateEnd)) {
            //   this.$message.error('当前选择的额度有效期小于原额度有效期')
            // }
            this.submitData.newIndateEnd = newIndateEnd
            this.submitData.approvePerson = this.approvePerson
            await addLimit(this.submitData);
            this.visible = false
            this.$message.success('提交成功', 4)
            this.$router.go(-1)
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    handleAfterClose() {
      this.id = null
      this.modalTitle = '延长有效期'
    },
    closeMessage() {
      this.visible = false
    }
  },
}
</script>
<style lang="less" scoped>
.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
</style>
